import { LINKEDIN_CLIENT_ID, AUTH_FRONTEND_URL } from 'helpers/config'
import { RequesterType } from 'helpers/types'

export type LinkedInStateObject = {
  redirectUrl: string
  action: 'LOGIN' | 'SIGNUP'
  productId?: string
  requester?: RequesterType
  overrideDefaultSignupAction?: string
}

const linkedin = {
  connect: (state: LinkedInStateObject) => {
    const searchParams = new URLSearchParams({
      response_type: 'code',
      client_id: LINKEDIN_CLIENT_ID,
      redirect_uri: `${AUTH_FRONTEND_URL}/linkedin`,
      state: JSON.stringify(state),
      scope: 'openid profile email',
    })

    const url = `https://www.linkedin.com/oauth/v2/authorization?${searchParams.toString()}`

    window.location.href = url
  },
}

export default linkedin
